export default "__VITE_ASSET__BjSlwoZU__"